import { useCallback, useState } from 'react';
import { NFT_FAVORITE_KEY } from './constants';
import { readFavoriteIdsFromStorage } from './utils/storage';
export function useFavoriteNfts() {
    const [favoriteNFTs, setFavoriteNFTs] = useState(() => readFavoriteIdsFromStorage(NFT_FAVORITE_KEY));
    const toggleFavoriteNFT = useCallback((nftId) => {
        setFavoriteNFTs((prev) => {
            const updatedFavorites = prev.includes(nftId)
                ? prev.filter((id) => id !== nftId)
                : [...prev, nftId];
            localStorage.setItem(NFT_FAVORITE_KEY, JSON.stringify(updatedFavorites));
            return updatedFavorites;
        });
    }, []);
    return { favoriteNFTs, toggleFavoriteNFT };
}
